<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text class="">
              <v-form v-model="valid">
                <v-btn icon style="right:10px" @click="openDialogUsers">
                  <v-icon>search</v-icon>
                </v-btn>
                사용자 검색
                <v-dialog v-model="users.dialog" max-width="1000px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">사용자 조회</span>
                    </v-card-title>
                    
                    <v-toolbar card color="white">
                      <div class="flex xs12 sm2">
                      <v-select
                        :items="[{
                                  text: '이름',
                                  value: 'name'
                                },
                                {
                                  text: '전화번호',
                                  value: 'phoneNumber'
                                }]"
                        name="header"
                        v-model="searchUsersFormModel.filter"    
                        label="header"
                      ></v-select> 
                      </div>
                      <v-text-field
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchUsersFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchUserFilter"
                      ></v-text-field>
                      <v-btn icon @click="searchUserFilter">
                        <v-icon>filter_list</v-icon>
                      </v-btn> 
                    </v-toolbar>        
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-data-table
                        :headers="complex.headers"
                        :items="complex.items"
                        :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                        class="elevation-1"
                        item-key="userId"
                        must-sort
                        :total-items="totalItems"
                        :loading="loading"
                        :pagination.sync="pagination"
                        v-model="complex.selected"
                        >
                        <template slot="items" slot-scope="props">
                          <td>
                            <v-checkbox
                              primary
                              hide-details
                              v-model="props.selected"
                            ></v-checkbox>
                          </td>                   
                          <td class="text-sm-center">{{ props.item.userId }}</td>
                          <td class="text-sm-center">{{ props.item.userType == 'P' ? '승객' : '기사' }}</td>
                          <td class="text-sm-center">{{ props.item.phoneNumber }}</td>
                          <td class="text-sm-center">{{ props.item.name }}</td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer>
                      </v-spacer>
                      <v-btn color="blue darken-1" flat @click="selectUsers">선택</v-btn>
                      <v-btn color="blue darken-1" flat @click="closeDialogUsers">닫기</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-text-field
                  label="수신인 번호"
                  name="receiver"
                  placeholder="ex) 01012345678, 01011112222 (최대 1000명까지)"
                  :rules="[this.validReceiver() || '최대 1000명까지 가능합니다.']"
                  ref="receiver"
                  v-model="formModel.receiver"
                  v-validate="'required'"
                  data-vv-name="receiver"     
                  :error-messages="errors.collect('receiver')"
                  required
                ></v-text-field> 
                <v-text-field
                  label="제목"
                  placeholder="LMS, SMS일 경우만 가능 (최대 44byte)"
                  name="title"      
                  :rules="[this.validTitle() || '최대 44byte 까지 가능합니다.']"
                  ref="title"
                  @input="changeTitle($event)"
                  :disabled="chkTitleDisabled"
                  v-model="formModel.title"
                ></v-text-field>
                <v-text-field
                  textarea
                  name="message"
                  label="내용"
                  placeholder="90bytes 미만은 SMS, 이상은 LMS (최대 2000byte)"
                  v-model="formModel.message"
                  v-validate="'required'"
                  data-vv-name="message"     
                  :error-messages="errors.collect('message')"
                  :rules="[this.validMessage() || '최대 2000byte 까지 가능합니다.']"
                  ref="message"
                  @input="changeTextarea($event)"
                  required>
                </v-text-field>
                * {{ msgByte }} byte
                <v-select
                  :items="msgType"
                  name="messageType"
                  v-validate="'required'"
                  data-vv-name="messageType"     
                  :error-messages="errors.collect('messageType')"           
                  v-model="formModel.messageType"
                  label="메세지 타입"
                  menu-props="auto"
                  required
                  disabled
                  item-text="text"
                  item-value="state"
                ></v-select>
                <v-checkbox
                  :label="`광고성 문자`"
                  v-model="formModel.isAdv"
                ></v-checkbox>
                <div class="form-btn">
                  <v-btn outline @click="submit" color="primary">전송</v-btn>
                </div>
                <div>
                   &nbsp;
                </div>
                <div>
                * 발송가능한 문자 수
                </div>
                <div>
                단문 : {{ remainCount == null ? '0' : remainCount.SMS_CNT }}건, 장문 : {{ remainCount == null ? '0' : remainCount.LMS_CNT }}건
                </div>
              </v-form>
            </v-card-text>       
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MsgType from '@/api/msgType';
export default {
  $_veeValidate: {
    validator: 'new'
  },    
  data () {
    return {
      remainCount: null,
      formModel: {
        message: '',
        receiver: '',
        messageType: 'SMS',
        title: '',
        isAdv: false
      },
      searchUsersFormModel: {
        filter: 'name',
        filterText: ''
      },
      msgType: MsgType,
      valid: true,
      chkTitleDisabled: true,
      titleByte: '0',
      msgByte: '0',
      formHasErrors: false,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      loading: true,
      totalItems: 0,
      prevData: null,
      users: {
        dialog: false
      },
      complex: {
        selected: [],
        headers: [
          {
            text: '',
            value: '',
            sortable: false,
            align: 'center'
          },
          {
            text: '사용자번호',
            value: 'userId',
            align: 'center'
          },
          {
            text: '사용자타입',
            value: 'userType',
            align: 'center'
          },
          {
            text: '전화번호',
            value: 'phoneNumber',
            align: 'center'
          },
          {
            text: '이름',
            value: 'name',
            align: 'center'
          },
        ],
        items: []
      }
    };
  },
  watch: {
    pagination: {
      handler () {
        this.searchUser();
      },
      deep: true
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.$validator.localize('en', this.dictionary);
    this.banbanCreated();
    
  },  
  methods: {
    banbanCreated () {
      const prameters = {
        method: 'smsRemainCount'
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          top.getApp.progress.dialog = false;
          this.remainCount = data;
          this.clear();
          if (this.$route.params.phoneNumber != null && this.$route.params.phoneNumber != '') {
            this.formModel.receiver = this.$route.params.phoneNumber;
          }
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    clear () {
      this.formModel = {
        message: '',
        receiver: '',
        messageType: 'SMS',
        title: '',
        isAdv: false
      };
      this.searchUsersFormModel = {
        filter: 'name',
        filterText: ''
      };
      this.complex.selected = [];
    },
    submit () {
      
      this.$validator.validateAll()
        .then((validate) => {
          if (validate && this.valids()) {
            const parameters = {
              method: 'sendingSMS',
              message: this.formModel.message,
              receiver: this.formModel.receiver,
              messageType: this.formModel.messageType,
              title: this.formModel.title,
              isAdv: this.formModel.isAdv
            };
            this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                top.getApp.progress.dialog = false;
                if (data.result_code >= 0) {
                  var msg = "총 : " + (data.success_cnt + data.error_cnt) +"건"
                    + "\n전송 성공 : " + data.success_cnt + "건"
                    + "\n전송 실패 : " + data.error_cnt + "건"
                  alert(msg);
                  this.banbanCreated();
                }
                else {
                  alert(data.message);
                }
              })
              .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
          }
       });;
    },
    changeTitle(event) {
      this.titleByte = this.getByteLenght(event);
    },
    changeTextarea(event) {
      this.msgByte = this.getByteLenght(event);
      
      if (this.msgByte < 90) {
        this.chkTitleDisabled = true;
        this.formModel.title = '';
        this.formModel.messageType = 'SMS';
      } else {
        this.chkTitleDisabled = false;
        this.formModel.messageType = 'LMS';
      }
    },
    getByteLenght(text) {
      var len = 0;
      var str = text.substring(0);
      if (str == null) return 0;
      for (var i=0; i < str.length; i++) {
        var ch = escape(str.charAt(i));
        if ( ch.length == 1) {
          len++;
        }
        else if (ch.indexOf("%u") != -1) {
          len +=2
        }
        else if (ch.indexOf("%") != -1) {
          len += ch.length/3;
        }
      }
      return len;
    },
    // validate가 안먹어서 어쩔수 없이...
    valids() {
      return this.validReceiver() && this.validTitle() && this.validMessage();
    },
    validReceiver() {
      return this.formModel.receiver.split(',').length <= 1000;
    },
    validTitle() {
      return this.titleByte <= 44;
    },
    validMessage() {
      return this.msgByte <= 2000;
    },
    openDialogUsers () {
      this.users.dialog = true;
      this.searchUser();
    },
    searchUser () {
      this.loading = true;

      const prameters = {
        method: 'searchUsers',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchUsersFormModel.filter,
        filterText: this.searchUsersFormModel.filterText
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          this.prevData = data;
          this.nextSearchUser()
            .then(data => {
              this.complex.items = data.items;
              this.totalItems = data.total;
            });
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
          });
    },
    nextSearchUser () {
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination

        let items = this.prevData.content;
        const total = this.prevData.totalElements;

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    searchUserFilter () {
      this.searchUser();
    },
    selectUsers () {
      for (let i = 0; i < this.complex.selected.length; i++) {
        if( i == 0 ) {
          this.formModel.receiver = this.complex.selected[i].phoneNumber;
        } else {
          this.formModel.receiver += ',' + this.complex.selected[i].phoneNumber;
        }
      }
      
      this.users.dialog = false;
    },
    closeDialogUsers () {
      this.users.dialog = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/sms/SendingSMS.vue